// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".network[data-v-21df621f]{align-items:center;display:flex;flex-direction:column;justify-content:center}.network img[data-v-21df621f]{height:120px;width:120px}.network .text[data-v-21df621f]{color:#000;font-size:20px;font-style:normal;font-weight:500;line-height:46px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
